import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsThisForSection() {
  return <section className="py-10 md:py-16 bg-brand-lightBlue" data-id="element-157">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-159">
          {/* Who it's for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-blue-100" data-id="element-160">
            <h3 className="text-xl font-bold text-brand-dark mb-4 flex items-center gap-3" data-id="element-161">
              <span className="bg-green-100 p-1.5 rounded-full text-green-600" data-id="element-162">
                <CheckIcon className="w-5 h-5" data-id="element-163" />
              </span>
              Who This Is For
            </h3>
            <ul className="space-y-3" data-id="element-164">
              {['Parents of toddlers (ages 1–4) planning their first flight.', 'Families embarking on long-haul road trips.', "Grandparents who want to stay 'prep-ready' for visiting toddlers.", "Travel-loving parents currently 'trapped' at home by the fear of a meltdown."].map((text, i) => <li key={i} className="flex gap-3 text-gray-700" data-id="element-165">
                  <CheckIcon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-166" />
                  <span data-id="element-167">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who it's NOT for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/60 p-6 rounded-2xl border border-gray-200" data-id="element-168">
            <h3 className="text-xl font-bold text-gray-500 mb-4 flex items-center gap-3" data-id="element-169">
              <span className="bg-red-50 p-1.5 rounded-full text-red-400" data-id="element-170">
                <XIcon className="w-5 h-5" data-id="element-171" />
              </span>
              Who This Is NOT For
            </h3>
            <ul className="space-y-3" data-id="element-172">
              {['Parents of teenagers or older children.', "People looking for 'medical' advice for child sedation.", "Anyone expecting a 'magic button' that makes a toddler sit perfectly still for 10 hours without engagement."].map((text, i) => <li key={i} className="flex gap-3 text-gray-500" data-id="element-173">
                  <XIcon className="w-5 h-5 text-red-300 shrink-0 mt-0.5" data-id="element-174" />
                  <span data-id="element-175">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}